import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _assessmentResponse = {};
var _captchaRequest = {};
var _captchaResponse = {};
function resolveComWixpressViCaptcharatorCaptchaServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/captcharator-web',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/_api/captcharator',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/captcharator',
                destPath: '',
            },
            {
                srcPath: '/_api/captcharator-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/captcha',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/captcha',
                destPath: '/api',
            },
            {
                srcPath: '/_api/captcharator',
                destPath: '',
            },
            {
                srcPath: '/_api/captcharator-web',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function authorize(payload) {
    var _a = serializer(_captchaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_captchaResponse, {}).fromJSON;
    function __authorize(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.captcharator.v1.captcha_entity',
            method: 'POST',
            methodFqn: 'com.wixpress.vi.captcharator.CaptchaService.authorize',
            url: resolveComWixpressViCaptcharatorCaptchaServiceUrl({
                protoPath: '/api/v1/authorize',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __authorize.fromReq = fromReq;
    return __authorize;
}
export function authorizeWithoutDomainValidation(payload) {
    var _a = serializer(_captchaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_captchaResponse, {}).fromJSON;
    function __authorizeWithoutDomainValidation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.captcharator.v1.captcha_entity',
            method: 'POST',
            methodFqn: 'com.wixpress.vi.captcharator.CaptchaService.authorizeWithoutDomainValidation',
            url: resolveComWixpressViCaptcharatorCaptchaServiceUrl({
                protoPath: '/api/v1/authorizeWithoutDomainValidation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __authorizeWithoutDomainValidation.fromReq = fromReq;
    return __authorizeWithoutDomainValidation;
}
export function assessment(payload) {
    var _a = serializer(_captchaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assessmentResponse, {}).fromJSON;
    function __assessment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.captcharator.v1.captcha_entity',
            method: 'POST',
            methodFqn: 'com.wixpress.vi.captcharator.CaptchaService.assessment',
            url: resolveComWixpressViCaptcharatorCaptchaServiceUrl({
                protoPath: '/api/v1/assessment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assessment.fromReq = fromReq;
    return __assessment;
}
//# sourceMappingURL=http.impl.js.map